// Sidebar — Düz liste (grup başlıkları kaldırıldı), alfabetik + sabit üst/alt yerleşim.
// Kontrol Paneli en üstte, Kullanıcılar/Ayarlar en altta, ortası alfabetik.
import { NavLink } from "react-router-dom";
import {
  LayoutDashboard, ScrollText, Wallet, CreditCard, RefreshCw, Repeat,
  Settings, CircleDollarSign, UserCog, Coins, Landmark,
} from "lucide-react";

// [ana seçenekler] — kullanıcı isteği: Kendi Çeklerimiz sayfası Cirolanan Çeklerin hemen altında.
// Bu yüzden alfabetik sıralama yerine sabit sıralama kullanıyoruz.
const MID = [
  { label: "Abonelikler",       to: "/subscriptions",     icon: Repeat },
  { label: "Alınan Çekler",     to: "/cheques/incoming",  icon: ScrollText },
  { label: "Bankaya Verilen Çekler", to: "/bank-cheques", icon: ScrollText },
  { label: "Cirolanan Çekler",  to: "/cheques/endorsed",  icon: ScrollText },
  { label: "Kendi Çeklerimiz",  to: "/cheques/own",       icon: ScrollText },
  { label: "Krediler",          to: "/credits",           icon: Landmark },
  { label: "DBS",               to: "/dbs",               icon: RefreshCw },
  { label: "Diğer Ödemeler",    to: "/other-payments",    icon: CircleDollarSign },
  { label: "Diğer Tahsilatlar", to: "/other-collections", icon: CircleDollarSign },
  { label: "Kasa",              to: "/cash",              icon: Wallet },
  { label: "Kredi Kartları",    to: "/credit-cards",      icon: CreditCard },
  { label: "POS Hareketleri",   to: "/pos",               icon: Coins },
];

const MENU = [
  { label: "Kontrol Paneli", to: "/", icon: LayoutDashboard, exact: true },
  ...MID,
  { label: "Kullanıcılar", to: "/users", icon: UserCog },
  { label: "Ayarlar",      to: "/settings", icon: Settings },
];

function Leaf({ item }) {
  const Icon = item.icon;
  return (
    <NavLink
      to={item.to}
      end={item.exact}
      data-testid={`sidebar-link-${item.to.replace(/\//g, '-')}`}
      className={({ isActive }) =>
        `flex items-center gap-3 px-3 py-2.5 text-sm rounded transition-colors ${
          isActive ? "bg-primary text-primary-foreground font-medium" : "hover:bg-muted"
        }`
      }
    >
      <Icon className="h-4 w-4 shrink-0" />
      <span>{item.label}</span>
    </NavLink>
  );
}

export function Sidebar({ onNavigate }) {
  return (
    <nav className="p-3 space-y-1 h-full overflow-y-auto" data-testid="sidebar">
      {/* Firma logosu + isim — sol üst */}
      <div className="px-3 py-3 mb-2 border-b border-border">
        <img
          src="/logo.jpg"
          alt="Has Yapı Orman Ürünleri"
          className="h-12 w-auto object-contain mb-2"
          data-testid="sidebar-logo"
        />
        <div className="font-heading font-bold text-base tracking-tight">Has Yapı</div>
        <div className="text-xs text-muted-foreground">Finans Yönetim Sistemi</div>
      </div>
      <div onClick={onNavigate}>
        {MENU.map((it) => <Leaf key={it.to} item={it} />)}
      </div>
    </nav>
  );
}
